export const permissionLog = (text: string) => {
  if (process.env.REACT_APP_PRODUCTION !== "true")
    console.log(`you do not have permission to access ${text}`);
};
